<template>
	<div style="padding-top:12px;background-color: #e4e4e4ef;">
		<!--    onload="this.height=ifd.document.body.scrollHeight" -->
		<iframe src="../../../static/BottomTab.html" name="ifd" onload="height=ifd.document.body.scrollHeight+30"
			width="100%" scrolling="no" frameborder="0"></iframe>
	</div>
</template>

<script>
	export default {
		name: "footers",
		data() {
			return {};
		},
		methods: {},
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/footer.vue